import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "./styles.css";

import { Button } from "@chakra-ui/react";
import { PopUpModal, Switcher } from "../../Components/Atoms";
import { LogoutIcon } from "../../Assets/images/svgs";
import PATHS from "../../Routes/paths";
import { SETTING_ROUTES } from "../../Library/constants";

const settingOptions = [
  { idx: 1, label: "Profile", path: SETTING_ROUTES.PROFILE.path },
  { idx: 2, label: "Clients", path: SETTING_ROUTES.CLIENTS.path },
  { idx: 3, label: "Models", path: SETTING_ROUTES.MODELS.path },
];

const settingRouteMap = {
  [SETTING_ROUTES.PROFILE.path]: SETTING_ROUTES["PROFILE"],
  [SETTING_ROUTES.MODELS.path] : SETTING_ROUTES["MODELS"],
  [SETTING_ROUTES.CLIENTS.path]: SETTING_ROUTES["CLIENTS"]
}

const Settings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const ACCESS_CODES = useRef(window.localStorage.getItem("accessCodes"));

  const getDefaultTab = () => {
    const route = settingRouteMap[location.pathname] || SETTING_ROUTES["PROFILE"];;

    if (location.pathname === PATHS.SETTINGS) navigate(route.path);
    const defaultActiveTab = settingOptions.find(option => option.path === route.path)
    return defaultActiveTab.idx;
  };

  const [selectedTab, setSelectedTab] = useState(getDefaultTab());
  const [confirmLogout, setConfirmLogout] = useState({});

  useEffect(() => {
    if (location.pathname === PATHS.SETTINGS) navigate(settingOptions[0].path);
  }, [location, navigate]);

  const handleLogout = () => {
    setConfirmLogout({
      open: true,
      modalMsg: "Are you sure you want to logout?",
      closeBtn: "Cancel",
      confirmBtn: "Logout",
      onModalClose: () => setConfirmLogout(null),
      onConfirm: () => navigate("/logout", { replace: true }),
    })
  };

  const changeTabAndNavigate = (tab) => {
    setSelectedTab(tab.idx);
    navigate(tab.path);
  };

  return (
    <section className={`panel-main settings-panel ${(!ACCESS_CODES.current || !ACCESS_CODES.current.length) ? "" : "hide-switcher"}`}>
      <header>
        {(!ACCESS_CODES.current || !ACCESS_CODES.current.length) ? <Switcher
          className="settings-switcher"
          options={settingOptions}
          selectedOption={selectedTab}
          handleChange={changeTabAndNavigate}
        /> : null}

        <Button
          onClick={handleLogout}
          rightIcon={<LogoutIcon />}
          colorScheme="whiteAlpha"
          variant="ghost"
        >
          Logout
        </Button>
      </header>

      <PopUpModal {...confirmLogout} />
      <Outlet />
    </section>
  );
};

export default Settings;
